export enum SessionStorageKey {
	UCID = 'ucid',
	ORIGIN = 'origin'
}
